/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

import { $$ } from 'utils/dom';

const landingpageCoverflows = $$('.landingpage-coverflow');

if (landingpageCoverflows.length) {
  landingpageCoverflows.forEach(coverflow => {
    const isCoverflow = coverflow.hasAttribute('data-swipercoverflow');
    const images = $$('img', coverflow);
    images.forEach(image => {
      image.classList.add('swiper-lazy');
    });
    const swiper = new Swiper(coverflow, {
      initialSlide: isCoverflow ? 1 : 0,
      effect: isCoverflow ? 'coverflow' : 'slide',
      loop: true,
      coverflowEffect: isCoverflow
        ? {
            rotate: 60,
            depth: 10,
          }
        : '',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      slideShadows: false,
      preloadImages: false,
      watchSlidesProgress: true,
      lazy: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      spaceBetween: isCoverflow ? 10 : 100,
      breakpoints: {
        601: {
          spaceBetween: isCoverflow ? 30 : 100,
        },
        901: {
          spaceBetween: isCoverflow ? 60 : 130,
        },
      },
    });
  });
}
